const PLATE_DEFAULT_REGEX = /[a-zA-Z]{3}\s*-\s*[0-9]{4}/;
const PLATE_MERCOSUL_REGEX = /[a-zA-Z]{3}[0-9]{1}[a-zA-Z]{1}[0-9]{2}/;

export const isValidLicensePlate = (plate: string): boolean =>
  !!(plate.match(PLATE_DEFAULT_REGEX) || plate.match(PLATE_MERCOSUL_REGEX));
